import { ConsoleLoggerAdapter, Logger as LoggerBuilder } from "@zetalabs/core";

export const DevLogger = new LoggerBuilder({
	adapter: ConsoleLoggerAdapter,
	showCallerLocation: true,
});
